/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
  GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams,
  GetApiV1ClassroomdisciplineSharedClassRooms401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassRooms.ts";

function getGetApiV1ClassroomdisciplineSharedClassRoomsUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/shared/class-rooms` as const,
  };
  return res;
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de salas ativas (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/class-rooms}
 */
export async function getApiV1ClassroomdisciplineSharedClassRooms(
  params?: GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassRooms401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineSharedClassRoomsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
